module.exports = __webpack_public_path__ + "static/Montserrat-100-b50f5872459e8e17eaffd5d57a2b2f8e.ttf";